module.exports = __webpack_public_path__ + "static/90-92402d1e201243236597afc44db68c39.png";